const LOGIN_ROUTE = '/auth/login'
const ORDERS_ROUTE = '/dashboard/orders'
const GENERAL_INFO = 'general-info'
const EDIT_GENERAL_INFO = 'edit-client'
const ORDER_HISTORY = 'order-history'
const BONUS_HISTORY = 'bonus-history'
const SAVED_ADDRESSES = 'saved-addresses'
const GUEST_METRICS = 'guest-metrics'
const FINANCIAL_METRICS = 'financial-metrics'
const MENU_METRICS = 'menu-metrics'
const LOYALTY_PROGRAMS = 'loyalty-programs'
const GCK = 'gck'
const DELIVERY = 'delivery'
const BRANCH = 'branch'
const MENU = 'menu'
const APP_INTERACTION = 'app-interaction'
const SATISFACTION = 'satisfaction'
const SOME_WRONG = '/500'
const KNOWLEDGE_BASE = '/dashboard/knowledge-base'

export const RouterPages = {
  login: LOGIN_ROUTE,
  orders: ORDERS_ROUTE,
  generalInfo: GENERAL_INFO,
  orderHsitory: ORDER_HISTORY,
  bonusHistory: BONUS_HISTORY,
  savedAddresses: SAVED_ADDRESSES,
  editGeneralInfo: EDIT_GENERAL_INFO,
  guestMetrics: GUEST_METRICS,
  financialMetrics: FINANCIAL_METRICS,
  menuMetrics: MENU_METRICS,
  loyaltyPrograms: LOYALTY_PROGRAMS,
  delivery: DELIVERY,
  branch: BRANCH,
  gck: GCK,
  menu: MENU,
  appInteraction: APP_INTERACTION,
  satisfaction: SATISFACTION,
  someWrong: SOME_WRONG,
  knowledgeBase: KNOWLEDGE_BASE,
}
